var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"local-material-page"},[_c('layout',{scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('local-material')]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }